/* eslint-disable react/prop-types */
import { Autocomplete, InputAdornment, TextField } from '@mui/material'
import { Search } from '@mui/icons-material'

/**
 * Renders a search field component for selecting multiple events and conversions.
 *
 * @param {Object} props - The component props.
 * @param {boolean} props.handleInputChange - A function to be called when the input changes
 * @param {boolean} props.loading - Indicates whether the options are currently loading.
 * @param {Array} [props.options=[]] - An array of options to be displayed in the search field.
 * @returns {JSX.Element} A React component representing the search field.
 */
function SearchField({ loading, handleInputChange, options = [] }) {
  return (
    <Autocomplete
      multiple
      limitTags={3}
      loading={loading}
      id="multiple-events"
      data-testid="multiple-events"
      options={options}
      sx={(theme) => ({
        bgcolor: theme.palette.colors.inputSearchBg,
        borderRadius: 1,
        '& .HiTheme-OutlinedInput-notchedOutline': {
          border: 'none',
        },
      })}
      disablePortal
      getOptionLabel={(option) => option.name}
      renderInput={(params) => (
        <TextField
          {...params}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <>
                <InputAdornment position="start">
                  <Search color="action" />
                </InputAdornment>
                {params.InputProps.startAdornment}
              </>
            ),
          }}
          data-testid="multiple-event-input"
          placeholder="Buscar por eventos e conversões"
        />
      )}
      onChange={handleInputChange}
      fullWidth
    />
  )
}

export default SearchField
